import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import useStyles from './styles';

export interface NavItemProps {
  icon: JSX.Element;
  title: string;
  active?: boolean;
  disabled?: boolean;
  onClick?: (args?: unknown) => unknown | undefined;
}

export const NavItem = ({ icon, title, active, disabled, onClick }: NavItemProps): JSX.Element => {
  const styles = useStyles();

  return (
    <ListItem className={styles.listItem} button key={title} selected={active} disabled={disabled} onClick={onClick}>
      <ListItemIcon className={styles.icon}>{icon}</ListItemIcon>
      <ListItemText primary={title} />
    </ListItem>
  );
};

export default NavItem;
